import {useEffect, useState} from 'react';

export const useDropdown = (ref) => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const node = ref.current;
        let timeout = null;

        const handleEnter = () => {
            clearTimeout(timeout)
            setOpen(true);
        }

        const handleLeave = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => setOpen(false), 100);
        }

        node.addEventListener("mouseenter", handleEnter);
        node.addEventListener("mouseleave", handleLeave);

        return () => {
            node.removeEventListener("mouseenter", handleEnter);
            node.removeEventListener("mouseleave", handleLeave);
        };
    }, [ref])

    return { open, setOpen };
}